<template>
  <section>
    <div class="container">
      <div class="title title--sm pb-30">
        <h1>Готовые решения</h1>
      </div>
      <nav class="tabs mb-60">
        <router-link to="/solutions">Оборудование</router-link>
        <router-link to="/solutions/programs">Программное обеспечение</router-link>
      </nav>
      <router-view></router-view>
    </div>
    <Clients />
    <VueFooter />
  </section>
</template>
<script>
const name = "Solutions"

import SvgIcon from '@/components/SvgIcon.vue'
import Clients from '@/components/Clients.vue'
import Equipment from '@/components/Equipment.vue'
import VueFooter from '@/components/VueFooter.vue'

export default {
  name,
  components: {
    Clients,
    VueFooter,
    SvgIcon,
    Equipment
  }
}

</script>
